module.exports = __webpack_public_path__ + "static/media/scan_sound.2a124340.mp3";